/**
 * Shown in place of "Loading..." when a page's background chart init was rejected (CU-17tm466jq2e).
 *
 * Some pages render only once their section exists. `useInitChartSection` issues a rejected init
 * once and never retries on its own, so without this panel the page waits forever. "Try Again"
 * calls the hook's `rearm()`, which issues the write once more.
 *
 * Mirrors the payment error panel in `components/payment/StripeCheckout.tsx`.
 */
export function ChartInitError({ onRetry }: { onRetry: () => void }) {
  return (
    <div id="chart-init-error" className="my-4 rounded-md border border-red-300 bg-red-50 p-6 text-center">
      <p className="text-lg font-semibold text-red-800">We couldn&apos;t set up this page.</p>
      <p className="mt-2 text-sm text-red-600">Nothing has been saved yet. Please try again.</p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-4 rounded-md bg-sky-700 px-6 py-2 text-white hover:bg-sky-800"
      >
        Try Again
      </button>
      <p className="mt-3 text-xs text-gray-500">
        If this issue persists, please contact{' '}
        <a href="mailto:info@mideohealth.com" className="underline">
          info@mideohealth.com
        </a>
      </p>
    </div>
  );
}
